<template>
  <component
    :is="getComponent(notice)"
    v-for="(notice, index) in noticeData"
    :key="index"
    :notice-detail="notice"
    :on-action-button-click="onActionButtonClick"
    :is-single-one="false"
  />
</template>

<script lang="ts" setup>
  import { type PropType } from 'vue'
  import { NoticeCategory } from '@/core/databus/IMessage'
  import type { NoticeDataType } from '@/core/Notification/NotificationManager'

  import ActionNoticeEmphasized from './ActionNoticeEmphasized.vue'
  import ActionNoticeWeak from './ActionNoticeWeak.vue'
  import NotificationTransmission from './NotificationTransmission.vue'
  import { noop } from 'lodash'

  const getComponent = (notice: NoticeDataType) => {
    switch (notice.category) {
      case NoticeCategory.TRANSMISSION:
        return NotificationTransmission

      case NoticeCategory.NOTICE:
        if (notice.isEmphasized) {
          return ActionNoticeEmphasized
        } else {
          return ActionNoticeWeak
        }

      default:
        break
    }
  }

  defineProps({
    noticeData: {
      type: Object as PropType<NoticeDataType[]>,
      default() {
        return []
      },
    },
    onActionButtonClick: {
      type: Function,
      default: noop,
    },
  })
</script>
<style scoped lang="stylus"></style>
